import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getObligationAssessmentResultFormConfig = () => {
  return {
    AssessmentId: {
      fieldId: 'AssessmentId',
      formLabel: t('assessmentResults.fields.Assessment'),
    },
    OversightAssessmentId: {
      fieldId: 'OversightAssessmentId',
      formLabel: t('assessmentResults.fields.OversightAssessment'),
    },
    InternalAuditReportId: {
      fieldId: 'InternalAuditReportId',
      formLabel: t('assessmentResults.fields.InternalAuditReport'),
    },
    ObligationIds: {
      fieldId: 'ObligationIds',
      formLabel: t('assessmentResults.fields.Obligation'),
    },
    Rating: {
      fieldId: 'Rating',
      formLabel: t('assessmentResults.fields.Rating'),
      displayType: { displayType: 'rating', ratingKey: 'performance_result' },
    },
    Rationale: {
      fieldId: 'Rationale',
      formLabel: t('assessmentResults.fields.Rationale'),
      displayType: { displayType: 'textarea' },
    },
    TestDate: {
      fieldId: 'TestDate',
      formLabel: t('assessmentResults.fields.TestDate'),
      displayType: { displayType: 'date' },
    },
    files: {
      fieldId: 'files',
      formLabel: t('assessmentResults.fields.newFiles'),
    },
  } as const satisfies FormConfig;
};
